<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">Acknowledgments for second novels should be briefer than those for first novels (which are written with the kitchen-sink sense that you’ll never get another such chance again). In keeping with that, then…</p>
<p>Thanks to my editor, Margaret O’Neill Marbury, who is as bright as she is beautiful and tall; to the entire RDI team, and especially Tania Charzewski, for patience above and beyond; and to my agent, Don Maass, who is equal measures of brilliant and kind.</p>
<p>Special thanks to those who helped me get right whatever I got right: Nicki and Phil Thomas, for making sure my British English was British enough (any inaccuracies that still stand are wholly my own fault); and Jim Wallace, for knowing a lot more about Halloween than I did.</p>
<p>Thanks, as always, to family and friends, for patience and for not killing me.</p>
<p>And thanks, also as always, to everyone who has been naughty and everyone who has been nice. Somehow, it all helps.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_acknowledgments.vue?5c08d898